// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type DiagramBuilder_DiagramFragment = { __typename?: 'Diagram', schemaVersion: number, content: { __typename?: 'DiagramContent', title: string, direction: Types.DiagramDirection, stages: Array<{ __typename?: 'DiagramStage', id: string, label?: string | null, dividerY?: number | null }>, nodes: Array<{ __typename?: 'DiagramBuilderNode', nodeID: string, kind: Types.DiagramNodeKind, subtype?: Types.DiagramNodeSubtype | null, memberNodeIds?: Array<string> | null, estateCategory?: Types.DiagramNodeEstateCategory | null, label: string, subtitle?: string | null, detail: string, footerLabel?: string | null, stageId?: string | null, position?: { __typename?: 'DiagramPosition', x: number, y: number } | null, nodeStyle?: { __typename?: 'DiagramNodeStyle', emphasis?: string | null, display?: string | null, icon?: string | null, color?: string | null, fontSize?: string | null, iconShape?: string | null, shape?: string | null, textAlign?: string | null, width?: number | null, height?: number | null, hideDetail?: boolean | null, hideFooterLabel?: boolean | null, fill?: string | null } | null }>, edges: Array<{ __typename?: 'DiagramBuilderEdge', edgeID: string, sourceNodeID: string, targetNodeID: string, label: string, labelPosition?: number | null, sourceSide?: Types.DiagramSide | null, targetSide?: Types.DiagramSide | null, waypoints?: Array<{ __typename?: 'DiagramPosition', x: number, y: number }> | null, edgeStyle?: { __typename?: 'DiagramEdgeStyle', lineStyle?: string | null, route?: string | null, strokeWidth?: number | null, color?: string | null, arrowheads?: string | null, hideLabel?: boolean | null } | null }> } };

export type DiagramBuilder_MessageContentFragment = { __typename?: 'DiagramMessageContent', turnID: string, diagramArtifactID?: string | null, revision?: number | null, diagram: (
    { __typename?: 'Diagram' }
    & DiagramBuilder_DiagramFragment
  ) };

export const Operations = {
  Fragment: {
    DiagramBuilder_Diagram: 'DiagramBuilder_Diagram' as const,
    DiagramBuilder_MessageContent: 'DiagramBuilder_MessageContent' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DiagramBuilder_DiagramFragmentDoc = gql`
    fragment DiagramBuilder_Diagram on Diagram {
  schemaVersion
  content {
    title
    direction
    stages {
      id
      label
      dividerY
    }
    nodes {
      nodeID
      kind
      subtype
      memberNodeIds
      estateCategory
      label
      subtitle
      detail
      footerLabel
      stageId
      position {
        x
        y
      }
      nodeStyle {
        emphasis
        display
        icon
        color
        fontSize
        iconShape
        shape
        textAlign
        width
        height
        hideDetail
        hideFooterLabel
        fill
      }
    }
    edges {
      edgeID
      sourceNodeID
      targetNodeID
      label
      labelPosition
      sourceSide
      targetSide
      waypoints {
        x
        y
      }
      edgeStyle {
        lineStyle
        route
        strokeWidth
        color
        arrowheads
        hideLabel
      }
    }
  }
}
    `;
export const DiagramBuilder_MessageContentFragmentDoc = gql`
    fragment DiagramBuilder_MessageContent on DiagramMessageContent {
  diagram {
    ...DiagramBuilder_Diagram
  }
  turnID
  diagramArtifactID
  revision
}
    ${DiagramBuilder_DiagramFragmentDoc}`;